// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css */

.slot-machine {
  text-align: center;
}

.slot-machine-reels {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.slot-machine-reel {
  margin: 0 10px;
  font-size: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":["/* src/App.css */\n\n.slot-machine {\n  text-align: center;\n}\n\n.slot-machine-reels {\n  display: flex;\n  justify-content: center;\n  margin: 20px 0;\n}\n\n.slot-machine-reel {\n  margin: 0 10px;\n  font-size: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
